import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TocActiveItem, TocIcon, TocItem, TocLink } from '../../styles';
import { DocsTocItem } from '../../types';
import { isTocItemActive, normalizePath } from '../../utils';

interface TocItemRowProps {
  item: DocsTocItem;
  pathname: string;
  hash: string;
}

export function TocItemRow({ item, pathname, hash }: TocItemRowProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = isTocItemActive(item, pathname, hash);
  const Wrapper = isActive ? TocActiveItem : TocItem;

  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    if (!item.route || !item.route.includes('#')) {
      return;
    }

    const [routePath, routeHash = ''] = item.route.split('#');
    if (!routeHash) {
      return;
    }

    const isSamePage =
      normalizePath(location.pathname) === normalizePath(routePath);
    if (!isSamePage) {
      return;
    }

    event.preventDefault();
    navigate(`${routePath}#${routeHash}`);

    window.requestAnimationFrame(() => {
      const target = document.getElementById(routeHash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  return (
    <Wrapper>
      {item.icon && <TocIcon>{item.icon}</TocIcon>}
      {item.route ? (
        <TocLink to={item.route} onClick={handleClick}>
          {item.label}
        </TocLink>
      ) : (
        <span>{item.label}</span>
      )}
    </Wrapper>
  );
}
